function getScrollParent(element: Element) {
    let parent = element.parentElement;

    while (parent) {
        const style = getComputedStyle(parent);
        const overflowY = style.overflowY;

        const isScrollable = (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") &&
            parent.scrollHeight > parent.clientHeight;

        if (isScrollable) {
            return parent;
        }

        parent = parent.parentElement;
    }

    // Default to scrolling the document if no scrollable parent is found
    return document.scrollingElement || document.documentElement;
}

export function scrollToTopOfClosestScrollableAncestor(element: Element) {
    const scrollParent = getScrollParent(element);
    scrollParent.scrollTo({ top: 0, behavior: "instant" });
}